import { Component, OnInit } from "@angular/core";
import { AuthService } from '@auth0/auth0-angular';
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { Title } from '@angular/platform-browser';
import { filter, map } from 'rxjs/operators';


@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"]
})
export class AppComponent implements OnInit{
  buttonId = "chatbase-bubble-button";
  button: HTMLElement;
  

  constructor(
    private titleService: Title,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public auth: AuthService
    ) { 
    // Subscribe to router events and filter only NavigationEnd events
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.waitForButtonAndMakeDraggable();
    });
  }

  ngOnInit() {
    // Ensure tracker starts on any route where user is already authenticated (e.g., after redirect)
    this.auth.user$.subscribe(user => {
      if (user) {
        try { (window as any).startOpenReplay?.(); } catch {}
        try {
          const email = (user as any)?.email;
          if (email && (window as any).tracker?.setUserID) {
            (window as any).tracker.setUserID(email);
          }
        } catch {}
      }
    });
    //this.titleService.setTitle('lets celebrate');
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(() => {
        let child = this.activatedRoute.firstChild;
        while (child.firstChild) {
          child = child.firstChild;
        }
        return child;
      }),
      filter(child => child.outlet === 'primary'),
      map(child => child.snapshot.data['title'])
    ).subscribe((title: string) => {
      this.titleService.setTitle(title);
    });
  }

  waitForButtonAndMakeDraggable() {
    const checkInterval = 100;
  
    const checkExist = setInterval(() => {
      this.button = document.getElementById(this.buttonId);
      const targetDiv = document.getElementById('container');
      
      // Check if we are on the login page
      const isLoginPage = window.location.href.indexOf('login') > -1;
  
      if (this.button) {
        if (isLoginPage) {
          // Hide the button instead of removing it
          this.button.style.display = 'none';
        } else {
          // Show the button if we are not on the login page
          if (targetDiv && !targetDiv.contains(this.button)) {
            console.log('adding button');
            targetDiv.appendChild(this.button);
          }
          this.button.style.display = 'block';
        }
  
        clearInterval(checkExist);  // Clear the interval after handling
      }
    }, checkInterval);
  }
  

  onDragStart(event) {
    console.log('drag start');
  }

  onDragEnd(event) {
    console.log('drag end');
    if (this.button) {
      this.button.setAttribute('disabled', 'true');
      setTimeout(() => {
        if (this.button) this.button.removeAttribute('disabled');
      }, 100);
    }
  }
}
